module.exports = __webpack_public_path__ + "static/media/ForceBalance.a85ca401.svg";